import UiButton3 from "./ui_button3";
import UiInput3 from "./ui_input3";
import UiTooltip from "./ui_tooltip";
import UserDisplayList from "./user_display_list";

const UserFragment = ({
    ww,
    search,
    setSearch,
    sortMode,
    setReloadList,
    displayUser,
    load,
    showCanvasHandler,
    sortModeHandler,
    baseUrl
}) => {
    return (
        <div style={{ maxWidth: 1600 }}>
            <div className={"gap-3 d-flex flex-column " + (ww < 400 ? "px-1 pt-4 " : "p-4")}>
                <div className={"d-flex justify-content-between gap-1 " + (ww < 500 ? "flex-column" : "")}>
                    <p className="mb-1 fs-4">Users</p>
                    <div className={"d-flex gap-2 " + (ww < 500 ? "flex-column w-100" : "")}>
                        <div>
                            <UiInput3 value={search} setSearch={setSearch} />
                        </div>

                        <div className="d-flex gap-1 justify-content-between" onClick={() => setReloadList(true)}>
                            <div className="flex-grow-1">
                                <UiButton3
                                    text={"Add User"} 
                                    left={true} 
                                    logo={baseUrl + "/src/plus.png"} 
                                    submit={() => showCanvasHandler("Add User", "user_add")} 
                                />
                            </div>
                            <UiTooltip title="Reload Table">
                                <div 
                                    style={{ 
                                        borderRadius: 100, 
                                        border: " 1px solid #650260", 
                                        width: 40, 
                                        height: 40, 
                                        cursor: "pointer" 
                                    }} 
                                    className="d-flex justify-content-center flex-shrink"
                                >
                                    <i 
                                        className="bi bi-arrow-clockwise fs-4 m-0 p-0 align-self-center" 
                                        style={{ color: "#650260" }}
                                    ></i>
                                </div>
                            </UiTooltip>
                        </div>
                    </div>
                </div>

                <div className="container1">
                    <div className="table-responsive">
                        <table className="brand-table">
                            <thead>
                                <tr>
                                    <th onClick={sortModeHandler}>
                                        <div className='d-flex gap-1 justify-content-between' style={{ cursor: "pointer" }}>
                                            <span></span>
                                            <span className='text-truncate align-self-center'>Email</span>
                                            {sortMode == 1 ?
                                                <i className="bi bi-caret-up-fill align-self-center"></i>
                                                :
                                                <i className="bi bi-caret-down-fill align-self-center"></i>
                                            }
                                        </div>
                                    </th>
                                    <th className="middle-row-th">Name</th>
                                    <th className="middle-row-th">Role</th>
                                    {/* <th className="middle-row-th">Subscribed</th> */}
                                    <th className="middle-row-th">Status</th>
                                    <th className="middle-row-th">Brand/Account Access</th>
                                    <th className="middle-row-th">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <UserDisplayList
                                    displayUser={displayUser}
                                    load={load}
                                    showCanvasHandler={showCanvasHandler}
                                    setReloadList={setReloadList} 
                                />
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserFragment;

